import React, { useEffect, useState } from 'react'
import { GoogleMap, useLoadScript, Marker, InfoWindow } from '@react-google-maps/api'
import { TextFinderVenues } from '../../../components/TextFinderVenues'
import { CardVenue } from '../../../components/Venues/CardVenue'
import { ArtistCard } from '../../../components/Events/ArtistCard'
import { eventService } from '../../../services/event.service'
import { venueService } from '../../../services/venue.service'
import { useAuth } from '../../../hooks/useAuth'
import { NothingToShow } from '../../../components/Dashboard/NothingToShow'
import { CategoryIconVenue } from '../../../components/CategoryIconVenue'
import { StateDropdown } from '../../../components/StateDropdown' // Lo agregué
import { DatePicker } from '../../../components/DatePicker' // Lo agregué
import { PricePicker } from '../../../components/PricePicker' // Lo agregué
import { Link } from 'react-router-dom'
import './style.scss'

export const ExploreVenue = ({ isAdmin }) => {
  const [events, setEvents] = useState([])
  const [venues, setVenues] = useState([])
  const [isRejected, setIsRejected] = useState(false)
  const [categorySelected, setCategorySelected] = useState(null)
  const [categoryName, setCategoryName] = useState(null)
  const [stateSelected, setStateSelected] = useState(null) // Lo agregué
  const [DateSelected, setDateSelected] = useState(null)
  const [stateName, setStateName] = useState(null) // Lo agregué
  const [monthFromSelected, setMonthFromSelected] = useState(null) // Lo agregué
  const [PricetoFind, setPriceToFind] = useState(null)
  const [monthFromName, setMonthFromName] = useState(null) // Lo agregué
  const [monthToSelected, setMonthToSelected] = useState(null) // Lo agregué
  const [monthToName, setMonthToName] = useState(null) // Lo agregué
  const [textToFind, setTextToFind] = useState(null)
  const [isShown, setIsShown] = useState('lista') // Lo agregué
  const [activeMarker, setActiveMarker] = useState(null)
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY
  })
  const [center, setCenter] = useState({ lat: 20.540732014384595, lng: -100.469693918325 })

  // hooks
  const { user } = useAuth()

  // Efectos
  useEffect(() => {
    const getVenues = async () => {
      try {
        const dbVenues = await venueService.getAllVenuesPublic()
        setVenues(dbVenues)
        // console.log(dbVenues)
      } catch (error) {
        console.log(error)
      }
    }
    getVenues()
  }, [])
  const handlerOnSubmit = (event) => {
    event.target.preventDefault()
  }
  const handleClick = () => {
    if (isShown === 'mapa') {
      setIsShown('lista')
    }
    if (isShown === 'lista') {
      setIsShown('mapa')
      const getUserLocation = () => {
        if (navigator.geolocation) {
          navigator.geolocation.getCurrentPosition(position => {
            setCenter({ lat: position.coords.latitude, lng: position.coords.longitude })
          })
        } else {
          console.log('Geolocation is not supported by this browser.')
        }
      }
      getUserLocation()
    }
  }
  const handleActiveMarker = (marker) => {
    if (marker === activeMarker) {
      return
    }
    setActiveMarker(marker)
  }

  let notFoundMessage = textToFind || ''
  if (!notFoundMessage) {
    notFoundMessage += categoryName || ''
    notFoundMessage += notFoundMessage ? (stateName !== null ? ` en ${stateName}` : '') : (stateName || '')
    if (monthFromSelected && monthToSelected && (monthFromSelected !== 'Invalid date') && (monthToSelected !== 'Invalid date')) {
      notFoundMessage += ` fecha:  ${monthFromSelected}`
    }
  }

  if (!isLoaded) return <></> // Lo agregué para que no se cargue el mapa hasta que se cargue el script
  const today = new Date()
  return (
    <>
        {/* Page content */}
        <section className="container mt-1 mb-lg-5 pt-lg-2 pb-5 event-discover white-text">
          <div className="row">
            <div className="justify-content-center inline-display px-4">
              <form className="row gy-2 d-flex justify-content" onSubmit={handlerOnSubmit}>
                <TextFinderVenues setTextToFind={setTextToFind} />
                {/* <DatePicker setMonthFromSelected={setMonthFromSelected} setMonthFromName={setMonthFromName} setMonthToSelected={setMonthToSelected} setMonthToName={setMonthToName}/> */}
              </form>
            </div>
          <div className="pb-4 align-items-center">
            <div className="row pb-4 pt-4">
              <div className="pb-4 align-items-center d-flex">
                <div className="scroll mb-n4 mx-n2">
                  <CategoryIconVenue categorySelected={categorySelected} setCategorySelected={setCategorySelected} setCategoryName={setCategoryName} />
                </div>
              </div>
            </div>
          <div>
          <div className="row">
          <div className="pb-4 align-items-center d-flex">
          <h2 className="mb-3 inline-display">
            Venues
          </h2>
          <div className="justify-content-center inline-display px-4">
            <button type="button" className="btn btn button btn-sm fs-sm rounded px-2"
            onClick={handleClick} >
            {isShown === 'lista'
              ? <><span className="px-1">Ver en el mapa</span><i className="bx bx-map bx-sm px-1" /></>
              : <><span className="px-1">Mostrar lista</span><i className="bx bx-list-ul bx-sm px-1" /></>
            }
            </button>
          </div>
          </div>
          {
              isShown === 'lista' && (
                venues.slice(0, 12).map((venue, index) => (

                <div className="col-12 col-md-3"
                  key={index}
                >
                  <CardVenue
                    setIsRejected={setIsRejected}
                    isRejected={isRejected}
                    isAdmin={isAdmin}
                    {...venue}
                  />
                </div>
                ))
              )
            }
            {
            isShown === 'mapa' && (
            <GoogleMap
            options= { { mapId: '73ae4e74dbf7fb53' } }
            zoom={13}
            center={center}
            mapContainerClassName="map-container"
            onClick={() => setActiveMarker(null)}
            >
            <Marker
            key = {'user-key-10'}
            position = {center}
            icon={{
              path: // User location icon without google maps
                'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z',
              fillColor: '#1E90FF',
              borderColor: '#00BFFF',
              fillOpacity: 1,
              strokeWeight: 0,
              scale: 2.1
            }}
            />
            {venues.map((venue, index) => (
            <Marker
            key={index} // Para que se muestren los marcadores el key tiene que ser dinámico
            position={{ lat: parseFloat(event.latitud), lng: parseFloat(event.longitud) }}
            onClick={() => handleActiveMarker(event.nombre)}
            animation={2}
            >
            {activeMarker === venue.nombre
              ? (
              <InfoWindow
              onCloseClick={() => setActiveMarker(null)}
              options={{ maxWidth: 320 }}
              >
                <>
                  <Link className='link' to={`/venue/${venue.nombre}`}>
                    <div className='img-container'>
                      <img className="infoimg" src={venue.foto_portada}/>
                    </div>
                    <div className = 'text-container'>
                      <h2 className='pt-1 text-black'>{venue.nombre}</h2>
                      <h3 className='pt-2 text-black'>{venue.ubicacion}</h3>
                    </div>
                  </Link>
                </>
              </InfoWindow>
                )
              : null}
            </Marker>
            ))}
          </GoogleMap>
            )}
          </div>
          </div>
          </div>
          </div>
        </section>
    </>
  )
}
